import React, { useState, useEffect } from 'react';
import NetflixSubscribe from './NetflixSubscribe';
import NetflixActivated from './NetflixActivated';
import NetflixNotActivated from './NetflixNotActivated';
import NetflixError from './NetflixError';
import { subInfo } from '../../Services/subInfo';
import { translations } from '../Text/translations';
import '../../css/netflix.scss';
import { setTrackingCookie } from '../../Utils/TrackingUtil';
import netflixLogo from '../../assets/netflix/netflix-r.svg';
import posterEn1x from '../../assets/netflix/Poster_en@1x.png';
import posterEn2x from '../../assets/netflix/Poster_en@2x.png';
import posterTc1x from '../../assets/netflix/Poster_tc@1x.png';
import posterTc2x from '../../assets/netflix/Poster_tc@2x.png';

const Netflix = ({
  currentLang = 'en',
  nowSessionId,
  loginUrl,
  fsaType,
  fsa,
  cust_type,
  mobilenowid,
  emailnowid,
  nickname
}) => {
  const [subscribedInd, setSubscribedInd] = useState('');
  const [activationStatus, setActivationStatus] = useState('');
  const [loading, setLoading] = useState(Boolean(nowSessionId));
  const [netflix_page_width, setNetflixPageWidth] = useState(0);
  const [poster_image, setPosterImage] = useState(posterEn1x);

  useEffect(() => {
    if(nowSessionId) {
      Promise.all([
        subInfo('NETFLIX')
      ]).then(([subInfoResponse]) => {
        if(subInfoResponse.subscribedInd)
          setSubscribedInd(subInfoResponse.subscribedInd);
        if(subInfoResponse.activationStatus)
          setActivationStatus(subInfoResponse.activationStatus);
        setLoading(false);
      }).catch((error) => {
        setLoading(false);
       // console.log(error);
      });
    } else {
      setLoading(false);
    }
 
  }, [fsaType, fsa, nowSessionId, cust_type]);  
  useEffect(() => {
    const onResize = () => setNetflixPageWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => {
        window.removeEventListener("resize", onResize);
    }
}, [setNetflixPageWidth]);
useEffect(() => {
  if(currentLang === 'en') {
    if(netflix_page_width <= 767) {
      setPosterImage(posterEn2x);
    } else {
      setPosterImage(posterEn1x);
    }
  } else {
    if(netflix_page_width <= 767) {
      setPosterImage(posterTc2x);
    } else {
      setPosterImage(posterTc1x);
    }
  }
}, [currentLang, netflix_page_width]);
  useEffect(()=>{
    setTrackingCookie();
  },[]);
  if (loading) {
    return (
      <div className="page-wrapper">
        <div className="container">
          <div className="netflix-wrapper text-center mt-5 mb-5">
            <img src={netflixLogo} alt="" className="logo" />
            <div className='message'>
              <h4>{translations[currentLang].netflixSubjectGreeting}{nickname || mobilenowid || emailnowid}{translations[currentLang].netflixSubjectGreeting2}</h4>
            </div>
            <div className="loading-wrapper show inline">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  const handleLogonButtonClick = () => {
    window.location.href = loginUrl;
  };

  return (
    <div className="page-wrapper">
      <div className="container">
        <div className="netflix-wrapper">
          <img src={netflixLogo} alt="" className="logo" />

          {!nowSessionId && (
  <>
    <div className="message">
      <h4>{translations[currentLang].netflixSubject}<br />{translations[currentLang].netflixSubject2}</h4>
    </div>
    <div className="cta-buttons">
    <p>{translations[currentLang].netflixActiviateAccountRemark}</p><br />
      <button className="btn primary" onClick={handleLogonButtonClick}>
        {translations[currentLang].activiateAccount}
      </button>
    </div>
  </>
)}
{(nowSessionId && (!fsa || !fsaType || (fsaType && subscribedInd === 'N'))) && (
  <NetflixSubscribe
    currentLang={currentLang} 
    nickname={nickname} 
    mobilenowid={mobilenowid} 
    emailnowid={emailnowid} 
  />
)}
{(fsaType && subscribedInd === 'Y' && activationStatus === 'Activated') && (
  <NetflixActivated
    currentLang={currentLang} 
    nickname={nickname} 
    mobilenowid={mobilenowid} 
    emailnowid={emailnowid} 
    fsa={fsa}
    fsaType={fsaType}
  />
)}
{(fsaType && subscribedInd === 'Y' && activationStatus === 'Enrolled') && (
  <NetflixNotActivated
   currentLang={currentLang} 
   nickname={nickname} 
   mobilenowid={mobilenowid} 
   emailnowid={emailnowid} 
   fsa={fsa}
   fsaType={fsaType}
/>
)}
{((nowSessionId && (fsaType && subscribedInd !== 'N' && subscribedInd !== 'Y'))) && (
    <NetflixError 
    currentLang={currentLang} 
    nickname={nickname} 
    mobilenowid={mobilenowid} 
    emailnowid={emailnowid} 
    fsa={fsa} 
    />
)}
          <div className="preview-img">
            <img src={poster_image} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Netflix;